module.exports = __webpack_public_path__ + "static/media/metal.ef71b819.wav";